import axios from "axios";

const getCategory = async (context) => {
    await context.commit('setCategory', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/category-list/`)).data
    if (response.success) {
        await context.commit('setCategory', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};


export default {
    getCategory,
}